// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2xvoz","amount":"Amount_amount__1Ebzf","tip":"Amount_tip__25cSl","tipHeader":"Amount_tipHeader__1429Q","tipsWrap":"Amount_tipsWrap__3fw2D"};